import request from '@/libs/request'

//用户咨询 列表
export function userInformationListApi (data) {
  return request({
    url: `user/userInformation`,
    method: 'get',
    params: data
  })
}

//用户咨询 详情
export function userInformationInfoApi (id) {
  return request({
    url: `user/userInformation/` + id,
    method: 'get'
  })
}


//用户咨询 编辑/添加
export function userInformationSaveApi (data) {
  return request({
    url: `user/userInformation`,
    method: 'post',
    data: data
  })
}

//用户咨询 删除
export function userInformationDelApi (id) {
  return request({
    url: `user/userInformation/` + id,
    method: 'delete'
  })
}


